import script from "./SystemParameterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemParameterForm.vue?vue&type=script&setup=true&lang=js"

import "./SystemParameterForm.vue?vue&type=style&index=0&id=7ea770db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea770db"]])

export default __exports__